const PREFIX = 'USER'

export const USER_LOADING_STATUS = `${PREFIX}_LOADING_STATUS`
export const USER_POPULAR_GET = `${PREFIX}_POPULAR_GET`
export const USER_POPULAR_GET_ERROR = `${PREFIX}_POPULAR_GET_ERROR`

export const USER_GET = `${PREFIX}_GET`
export const SPEAKER_GET = `${PREFIX}_SPEAKER_GET`
export const SPEAKER_SESSIONS_GET = `${PREFIX}_SPEAKER_SESSIONS_GET`
export const SET_SPEAKER_SESSION_LOADING_ID = `${PREFIX}_SET_SPEAKER_SESSION_LOADING_ID`
export const TOGGLE_IS_SPEAKER_SESSION_LOADING = `${PREFIX}_TOGGLE_IS_SPEAKER_SESSION_LOADING`
export const UPDATE_SPEAKER_SESSION = `${PREFIX}_UPDATE_SPEAKER_SESSION`
export const SESSION_META_GET = `${PREFIX}_SESSION_META_GET`
export const USER_GET_ERROR = `${PREFIX}_GET_ERROR`

export const USER_FOLLOW_STATUS = `${PREFIX}_FOLLOW_STATUS`
export const USER_FOLLOW = `${PREFIX}_FOLLOW`
export const USER_FOLLOW_ERROR = `${PREFIX}_FOLLOW_ERROR`

export const USER_UNFOLLOW_FROM_LIST_STATUS = `${PREFIX}_UNFOLLOW_FROM_LIST_STATUS`
export const USER_UNFOLLOW_FROM_LIST = `${PREFIX}_UNFOLLOW_FROM_LIST`
export const USER_UNFOLLOW_FROM_LIST_ERROR = `${PREFIX}_UNFOLLOW_FROM_LIST_ERROR`

export const USER_UNFOLLOW_STATUS = `${PREFIX}_UNFOLLOW_STATUS`
export const USER_UNFOLLOW = `${PREFIX}_UNFOLLOW`
export const USER_UNFOLLOW_ERROR = `${PREFIX}_UNFOLLOW_ERROR`

export const USER_GET_FOLLOWERS_STATUS = `${PREFIX}_GET_FOLLOWERS_STATUS`
export const USER_GET_FOLLOWERS = `${PREFIX}_GET_FOLLOWERS`
export const USER_GET_FOLLOWERS_ERROR = `${PREFIX}_GET_FOLLOWERS_ERROR`

export const USER_GET_FOLLOWINGS_STATUS = `${PREFIX}_GET_FOLLOWINGS_STATUS`
export const USER_GET_FOLLOWINGS = `${PREFIX}_GET_FOLLOWINGS`
export const USER_GET_FOLLOWINGS_ERROR = `${PREFIX}_GET_FOLLOWINGS_ERROR`

export const USER_SHOW_SUCCESS_ALERT = `${PREFIX}_SHOW_SUCCESS_ALERT`
export const USER_SHOW_ERROR_ALERT = `${PREFIX}_SHOW_ERROR_ALERT`
